import React from 'react'
import { useEffect, useState } from 'react';
import { useNavigate,useLocation, Link } from 'react-router-dom';
import api from '../API/api';
import Alert from '../Modals/Alert';
import { useRef } from 'react';
import Loader from '../Modals/Loader';
import { object, string, number, date, InferType,array ,bool} from 'yup';

export const Reset = () => {
  const [email,changeEmail] = useState('');
  const navigate = useNavigate()
  const alertRef = useRef();
  const loaderRef = useRef()
  const [alertMessage,setAlertMessage] = useState(null)

  const emailSchema = object({
    email:string().email('Put a valid email')
  })
  const data = {
    email:email
  }

  const confirmEmail = async (e) => {
    e.preventDefault()
    if(email === null || email === ''){
        console.log('email is null')
        setAlertMessage('Please provide an email address')
        alertRef.current.toggleState()
        return
    }

    try {
        loaderRef.current.toggleState()
        
        const verifiedEmail = await emailSchema.validate(data);

        const response =  await api.post(`/users/resetEmail`,data)
    
      if(response.request.status === 200){
            navigate(`/resetPassword`,{state:{token:response.data}})
            return

      } else {

        return
      }
    } catch (e){
        console.log(e)
        setAlertMessage('Provide a valid email')
        loaderRef.current.toggleState()
        alertRef.current.toggleState()
    }
    
      
    }

  return (
    <>
      <div className="flex flex-col w-full items-center justify-center text-center min-h-screen bg-gray-100 py-2 px-20">
      <div className="bg-white rounded-2xl shadow-2xl flex w-2/3 max-w-4xl">
        <div className="w-3/5 p-5">
          <div className="text-left font-bold">
          Password Reset
          </div>
          <div className="py-10">
            <h2 className="font-bold text-3xl mb-20">Enter user Email</h2>
  
            <div className="flex flex-col items-center">
              <div className="bg-gray-100 w-64 flex items-center mb-3">
                <input onChange={(e)=>{changeEmail(e.target.value)}} type="email" name="email" placeholder="Email" className="bg-gray-100 border py-2.5 px-3 border-gray-300 outline-none flex-1 text-sm focus:outline-none focus:border-black focus:ring-1 focus:ring-black" ></input>
              </div>
              <a href="#" onClick={(e)=>confirmEmail(e)} className="border-2 border-precision rounded-full px-12 py-2 inline-block font-semibold hover:bg-precision hover:text-white disabled:cursor-not-allowed" >Submit</a>
            </div>
          </div>
        </div>
        <div className="w-2/5 bg-[#1C1C1C] text-white rounded-tr-2xl rounded-br-2xl py-36 px-12">
          <h3 className="text-3xl font-bold mb-2">Propel Health</h3>
          <div className="border-2 w-40 border-white inline-block"></div>
        </div>
      </div>
    </div>
    <Alert ref={alertRef} message={alertMessage}/>
    <Loader ref={loaderRef}/>
    </>
    
  )
}
